import type { DataTableColumn as GridColDef } from '@/components/custom/erp';
import { formatDate, formatMoney, roundNumber } from '@/lib/formatUtils';
import { DETAIL_BY_OPTIONS } from './constant';

export const invoiceReportColumns = (detail_by?: number): GridColDef[] => [
  {
    field: 'ma',
    headerName: `Mã ${DETAIL_BY_OPTIONS.find(option => option.value === detail_by)?.label}`,
    width: 140,
    cellClassName: params => (params.row.is_group ? 'font-bold' : '')
  },
  {
    field: 'ten',
    headerName: `Tên ${DETAIL_BY_OPTIONS.find(option => option.value === detail_by)?.label}`,
    width: 250,
    cellClassName: params => (params.row.is_group ? 'font-bold' : '')
  },
  {
    field: 'sl_nhap',
    headerName: 'Số lượng',
    width: 120,
    type: 'number',
    renderCell: params => formatMoney(roundNumber(params.value)),
    cellClassName: params => (params.row.is_group ? 'font-bold' : '')
  },
  {
    field: 'gia',
    headerName: 'Giá',
    width: 120,
    type: 'number',
    renderCell: params => formatMoney(roundNumber(params.value)),
    cellClassName: params => (params.row.is_group ? 'font-bold' : '')
  },
  {
    field: 'tien_nhap',
    headerName: 'Tiền',
    width: 120,
    type: 'number',
    renderCell: params => formatMoney(roundNumber(params.value)),
    cellClassName: params => (params.row.is_group ? 'font-bold' : '')
  },
  {
    field: 'thue',
    headerName: 'Thuế',
    width: 120,
    type: 'number',
    renderCell: params => formatMoney(roundNumber(params.value)),
    cellClassName: params => (params.row.is_group ? 'font-bold' : '')
  },
  {
    field: 'cp',
    headerName: 'Chi phí',
    width: 120,
    type: 'number',
    renderCell: params => formatMoney(roundNumber(params.value)),
    cellClassName: params => (params.row.is_group ? 'font-bold' : '')
  }
];
